import { HOST_URL } from '../config'
import { HttpStatus } from '../constants/http-status.enum'
import type { ApiResponse } from './index'

export interface Ltsp101CatalogSyrup {
    id: number
    name: string
    description: string
    nameHe: string
    descriptionHe: string
    packageSize: number
    imageId?: number | null
    createdAt: string
    updatedAt: string
}

export interface Ltsp101CatalogDrink {
    id: number
    title: string
    description: string
    titleHe: string
    descriptionHe: string
    baseChannel: number
    flavourChannel: number
    brixRatioA: number
    brixRatioB: number
    createdAt: string
    updatedAt: string
}

export interface Ltsp101CatalogImage {
    id: number
    title: string
    titleHe: string
    notes: string
    notesHe: string
    imageBase64: string
    imageMime: string
    imageName: string
    createdAt: string
    updatedAt: string
}

export type Ltsp101CatalogSyrupCreate = Omit<Ltsp101CatalogSyrup, 'id' | 'createdAt' | 'updatedAt'>
export type Ltsp101CatalogSyrupUpdate = Partial<Ltsp101CatalogSyrupCreate>

export type Ltsp101CatalogDrinkCreate = Omit<Ltsp101CatalogDrink, 'id' | 'createdAt' | 'updatedAt'>
export type Ltsp101CatalogDrinkUpdate = Partial<Ltsp101CatalogDrinkCreate>

export type Ltsp101CatalogImageCreate = Omit<Ltsp101CatalogImage, 'id' | 'createdAt' | 'updatedAt'>
export type Ltsp101CatalogImageUpdate = Partial<Ltsp101CatalogImageCreate>

export async function listLtsp101CatalogSyrups(): Promise<ApiResponse<Ltsp101CatalogSyrup[]>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/syrups`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogSyrup[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getLtsp101CatalogSyrup(id: number): Promise<ApiResponse<Ltsp101CatalogSyrup>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/syrups/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogSyrup>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function createLtsp101CatalogSyrup(
    data: Ltsp101CatalogSyrupCreate,
): Promise<ApiResponse<Ltsp101CatalogSyrup>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/syrups`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogSyrup>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateLtsp101CatalogSyrup(
    id: number,
    data: Ltsp101CatalogSyrupUpdate,
): Promise<ApiResponse<Ltsp101CatalogSyrup>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/syrups/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogSyrup>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function deleteLtsp101CatalogSyrup(id: number): Promise<ApiResponse<Ltsp101CatalogSyrup>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/syrups/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogSyrup>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function listLtsp101CatalogDrinks(): Promise<ApiResponse<Ltsp101CatalogDrink[]>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/drinks`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogDrink[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getLtsp101CatalogDrink(id: number): Promise<ApiResponse<Ltsp101CatalogDrink>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/drinks/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogDrink>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function createLtsp101CatalogDrink(
    data: Ltsp101CatalogDrinkCreate,
): Promise<ApiResponse<Ltsp101CatalogDrink>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/drinks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogDrink>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateLtsp101CatalogDrink(
    id: number,
    data: Ltsp101CatalogDrinkUpdate,
): Promise<ApiResponse<Ltsp101CatalogDrink>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/drinks/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogDrink>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function deleteLtsp101CatalogDrink(id: number): Promise<ApiResponse<Ltsp101CatalogDrink>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/drinks/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogDrink>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function listLtsp101CatalogImages(): Promise<ApiResponse<Ltsp101CatalogImage[]>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/images`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogImage[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getLtsp101CatalogImage(id: number): Promise<ApiResponse<Ltsp101CatalogImage>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/images/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogImage>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function createLtsp101CatalogImage(
    data: Ltsp101CatalogImageCreate,
): Promise<ApiResponse<Ltsp101CatalogImage>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/images`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogImage>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateLtsp101CatalogImage(
    id: number,
    data: Ltsp101CatalogImageUpdate,
): Promise<ApiResponse<Ltsp101CatalogImage>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/images/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogImage>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function deleteLtsp101CatalogImage(id: number): Promise<ApiResponse<Ltsp101CatalogImage>> {
    const response = await fetch(`${HOST_URL}ltsp101/catalog/images/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<Ltsp101CatalogImage>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
